// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roboto */
 


html,
body,
#root,
.app,
.content {
  height: 100vh;
  width: 99vw;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans","Liberation Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
  margin: 0;
}

.app {
  display: flex;
  position: relative;
}

.content {
  height: 100%;
  overflow-y: auto;
}

.content2 {
  display: flex;
  margin-top: 70px;
}

.content3 {
  height: 100%;
  right: 0;
  position: absolute;
}

.max-sidebar {
  width: calc(100% - 280px);
  transition: right 1s ease;
  /* transform: translateX(200px); */
}

.min-sidebar {
  width: calc(100% - 90px);
  transition: left 1s ease;
}

.sidebar-box {
  height: 100vh;
  position: fixed;
  z-index: 5;
}

.navbar {
  width: 100%;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10;
}


/* Scrollbar */
::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: #e0e0e0;
}

::-webkit-scrollbar-thumb {
  background: #888;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}



@keyframes slideIn {
  0% {
    right: 0;
  }
  100% {
    right: -200px;
  }
}

@keyframes slideOut {
  0% {
    right: 0;
  }
  100% {
    right: -200px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAE8F,WAAW;;;;AAIzG;;;;;EAKE,aAAa;EACb,WAAW;EACX,yMAAyM;EACzM,SAAS;AACX;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,WAAW;EACX,WAAW;AACb;;;AAGA,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,aAAa;EACf;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Source+Sans+3:wght@400;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap'); /* Roboto */\n \n\n\nhtml,\nbody,\n#root,\n.app,\n.content {\n  height: 100vh;\n  width: 99vw;\n  font-family: -apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",\"Liberation Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";\n  margin: 0;\n}\n\n.app {\n  display: flex;\n  position: relative;\n}\n\n.content {\n  height: 100%;\n  overflow-y: auto;\n}\n\n.content2 {\n  display: flex;\n  margin-top: 70px;\n}\n\n.content3 {\n  height: 100%;\n  right: 0;\n  position: absolute;\n}\n\n.max-sidebar {\n  width: calc(100% - 280px);\n  transition: right 1s ease;\n  /* transform: translateX(200px); */\n}\n\n.min-sidebar {\n  width: calc(100% - 90px);\n  transition: left 1s ease;\n}\n\n.sidebar-box {\n  height: 100vh;\n  position: fixed;\n  z-index: 5;\n}\n\n.navbar {\n  width: 100%;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 10;\n}\n\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #e0e0e0;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n\n\n@keyframes slideIn {\n  0% {\n    right: 0;\n  }\n  100% {\n    right: -200px;\n  }\n}\n\n@keyframes slideOut {\n  0% {\n    right: 0;\n  }\n  100% {\n    right: -200px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
